import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ALL_PRODUCTS } from '../lib/products';

const COMPARISON_FEATURES = [
  { key: 'channels', label: '多渠道接入', values: ['微信/网站', '微信/网站', '企业微信', '支持定制'] },
  { key: 'ai_responses', label: 'AI智能回复', values: [true, true, true, true] },
  { key: 'knowledge_base', label: '知识库管理', values: [false, true, true, true] },
  { key: 'api_access', label: 'API接口', values: [false, false, true, true] },
  { key: 'private_deploy', label: '私有化部署', values: [false, false, false, true] },
  { key: 'custom_model', label: '专属模型微调', values: [false, false, false, true] },
  { key: 'account_limit', label: '账号数量', values: ['1账号', '5账号', '20账号', '不限'] },
  { key: 'support', label: '客户支持', values: ['标准', '标准', '优先', '专属顾问'] },
  { key: 'data_reports', label: '数据报表', values: ['基础', '完整', '完整+预测', '定制'] },
];

const ALL_FAQS = [
  {
    category: '通用问题',
    items: [
      { q: '可以先试用吗？', a: '可以。我们提供15天免费演示期，全功能体验。首月5折优惠，降低您的决策风险。' },
      { q: '合同周期是多久？', a: '主要产品支持月付和年付两种方式，年付享85折优惠。定制服务按项目签订年度维保合同。' },
      { q: '数据安全如何保障？', a: '所有数据传输采用TLS加密，企业版支持私有化部署，确保数据不出您的网络。' },
      { q: '需要技术背景吗？', a: '完全不需要。智纬AI平台设计为零代码操作，从创建到部署全程可视化。' },
    ],
  },
  {
    category: '产品选型',
    items: [
      { q: '智小客和销小帮有什么区别？', a: '智小客侧重客服场景（自动回复、FAQ、分流）；销小帮侧重销售场景（客户画像、话术推荐、商机跟进）。可以根据您的核心需求选择，也可组合使用。' },
      { q: '中小企业适合哪个产品？', a: '如果内部流程复杂（审批、会议、知识管理）选办小助；如果需要对外获客（客服、销售）选智小客或销小帮。' },
      { q: '全定制服务适合什么场景？', a: '行业壁垒高（如医疗、法律、金融）、数据安全要求极高、或需要深度私有化部署的企业。' },
      { q: '可以同时使用多个产品吗？', a: '可以。我们的产品可独立使用也可组合，打包使用享折扣优惠。' },
    ],
  },
  {
    category: '部署与上线',
    items: [
      { q: '上线需要多长时间？', a: '标准产品1-3个工作日完成配置。定制服务根据复杂度，一般2-4周交付。' },
      { q: '支持哪些部署方式？', a: '支持公有云、混合云、私有化部署。企业版及以上可选私有化。' },
      { q: '如何对接现有系统？', a: '提供标准API接口，支持与企业微信、钉钉、CRM、ERP等系统对接。企业版提供对接支持服务。' },
      { q: '售后服务有哪些？', a: '标准版：工单支持+文档；企业版：优先响应+月度回访；定制：7×24专属顾问+年度战略咨询。' },
    ],
  },
];

export function PricingOverviewPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [openCategory, setOpenCategory] = useState<number>(0);
  const [formData, setFormData] = useState({ name: '', company: '', phone: '', need: '' });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [billingCycle, setBillingCycle] = useState<'monthly' | 'annual'>('annual');

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
  };

  return (
    <div className="min-w-0">
      {/* Nav */}
      <nav className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">智</span>
              </div>
              <span className="text-xl font-bold text-gray-900">智纬AI</span>
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/#products" className="text-gray-600 hover:text-gray-900 text-sm font-medium">产品</Link>
              <Link to="/pricing" className="text-gray-600 hover:text-gray-900 text-sm font-medium">定价</Link>
              <a href="#comparison" className="text-gray-600 hover:text-gray-900 text-sm font-medium">对比表</a>
              <a href="#faq" className="text-gray-600 hover:text-gray-900 text-sm font-medium">常见问题</a>
              <a href="#contact" className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition">
                立即咨询
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="bg-gradient-to-br from-blue-50 via-white to-purple-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">简单透明的定价</h1>
          <p className="text-xl text-gray-600 mb-8">月付降低门槛，年付享85折优惠 · 无隐藏费用</p>
          {/* Billing toggle */}
          <div className="inline-flex items-center gap-3 bg-white rounded-full p-1 border border-gray-200 shadow-sm">
            <button
              onClick={() => setBillingCycle('monthly')}
              className={`px-5 py-2 rounded-full text-sm font-medium transition ${
                billingCycle === 'monthly'
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              月付
            </button>
            <button
              onClick={() => setBillingCycle('annual')}
              className={`px-5 py-2 rounded-full text-sm font-medium transition flex items-center gap-1 ${
                billingCycle === 'annual'
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              年付 <span className="text-xs bg-green-100 text-green-700 px-1.5 py-0.5 rounded-full">省15%</span>
            </button>
          </div>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-6">
            {ALL_PRODUCTS.map((product) => {
              const displayPrice = billingCycle === 'annual' && product.price !== '30,000+'
                ? Math.round(Number(product.price.replace(',', '')) * 0.85).toLocaleString()
                : product.price;
              return (
                <div
                  key={product.id}
                  className={`rounded-2xl p-6 flex flex-col ${
                    product.highlight
                      ? 'bg-gradient-to-br from-purple-600 to-blue-600 text-white shadow-xl scale-105'
                      : 'bg-white border border-gray-200 shadow-sm'
                  }`}
                >
                  {product.highlight && (
                    <div className="inline-flex items-center gap-1 text-xs font-semibold text-yellow-300 mb-3">
                      <span>★</span> 最受欢迎
                    </div>
                  )}
                  <div className="text-3xl mb-2">{product.emoji}</div>
                  <h3 className={`text-xl font-bold ${product.highlight ? 'text-white' : 'text-gray-900'}`}>
                    {product.name}
                  </h3>
                  <p className={`text-sm mb-4 ${product.highlight ? 'text-purple-200' : 'text-gray-500'}`}>
                    {product.tagline}
                  </p>
                  <div className="mb-1">
                    <span className={`text-3xl font-bold ${product.highlight ? 'text-white' : 'text-gray-900'}`}>
                      ¥{displayPrice}
                    </span>
                    {product.price !== '30,000+' && (
                      <span className={`text-sm ${product.highlight ? 'text-purple-200' : 'text-gray-400'}`}>
                        /{billingCycle === 'annual' ? '月' : '月'}
                      </span>
                    )}
                  </div>
                  {billingCycle === 'annual' && product.price !== '30,000+' && (
                    <p className={`text-xs mb-4 ${product.highlight ? 'text-purple-200' : 'text-gray-400'}`}>
                      年付折合 ¥{Math.round(Number(product.price.replace(',', '')) * 12 * 0.85).toLocaleString()}/年
                    </p>
                  )}
                  <Link
                    to={`/product/${product.id}`}
                    className={`mt-auto w-full py-2.5 rounded-lg text-center text-sm font-semibold transition ${
                      product.highlight
                        ? 'bg-white text-purple-600 hover:bg-purple-50'
                        : 'bg-gray-900 text-white hover:bg-gray-800'
                    }`}
                  >
                    查看详情
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section id="comparison" className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">产品功能对比</h2>
            <p className="text-gray-600">快速对比四款产品的核心差异</p>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left px-6 py-4 text-sm font-semibold text-gray-900 w-1/4">功能</th>
                  {ALL_PRODUCTS.map((p) => (
                    <th key={p.id} className="text-center px-4 py-4 w-1/5">
                      <div className="flex flex-col items-center gap-1">
                        <span className="text-2xl">{p.emoji}</span>
                        <span className="text-sm font-semibold text-gray-900">{p.name}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {COMPARISON_FEATURES.map((row, i) => (
                  <tr key={row.key} className={`border-b border-gray-100 ${i % 2 === 0 ? 'bg-gray-50/50' : 'bg-white'}`}>
                    <td className="px-6 py-3 text-sm text-gray-700 font-medium">{row.label}</td>
                    {row.values.map((val, j) => (
                      <td key={j} className="text-center px-4 py-3">
                        {typeof val === 'boolean' ? (
                          val ? (
                            <svg className="w-5 h-5 text-green-500 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          ) : (
                            <span className="text-gray-300 text-sm">—</span>
                          )
                        ) : (
                          <span className={`text-sm ${j === 1 ? 'font-semibold text-purple-600' : 'text-gray-700'}`}>
                            {val}
                          </span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
                <tr>
                  <td className="px-6 py-4 text-sm font-semibold text-gray-900">立即体验</td>
                  {ALL_PRODUCTS.map((p) => (
                    <td key={p.id} className="text-center px-4 py-4">
                      <Link
                        to={`/product/${p.id}`}
                        className={`inline-block px-4 py-2 rounded-lg text-sm font-medium ${
                          p.highlight
                            ? 'bg-purple-600 text-white hover:bg-purple-700'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                      >
                        查看详情
                      </Link>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">常见问题</h2>
          </div>
          {/* Category tabs */}
          <div className="flex gap-2 mb-6 flex-wrap">
            {ALL_FAQS.map((cat, i) => (
              <button
                key={i}
                onClick={() => setOpenCategory(i)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition ${
                  openCategory === i
                    ? 'bg-blue-100 text-blue-700'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {cat.category}
              </button>
            ))}
          </div>
          <div className="space-y-3">
            {ALL_FAQS[openCategory].items.map((faq, i) => {
              const globalIndex = ALL_FAQS.slice(0, openCategory).reduce((acc, cat) => acc + cat.items.length, 0) + i;
              return (
                <div key={i} className="border border-gray-200 rounded-xl overflow-hidden">
                  <button
                    className="w-full text-left px-6 py-4 flex justify-between items-center gap-4 hover:bg-gray-50 transition"
                    onClick={() => setOpenFaq(openFaq === globalIndex ? null : globalIndex)}
                  >
                    <span className="font-medium text-gray-900">{faq.q}</span>
                    <svg
                      className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform ${openFaq === globalIndex ? 'rotate-180' : ''}`}
                      fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openFaq === globalIndex && (
                    <div className="px-6 pb-4 text-gray-600 text-sm leading-relaxed">{faq.a}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="py-20 bg-gradient-to-br from-blue-600 to-purple-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white mb-10">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4">还有问题？预约咨询</h2>
            <p className="text-blue-100">我们的产品顾问将为您量身推荐最适合的方案</p>
          </div>
          {formSubmitted ? (
            <div className="bg-white rounded-2xl p-8 text-center shadow-xl max-w-lg mx-auto">
              <div className="text-5xl mb-4">🎉</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">预约成功！</h3>
              <p className="text-gray-600 text-sm">我们的顾问将在 <strong>24小时</strong> 内联系您</p>
            </div>
          ) : (
            <form onSubmit={handleFormSubmit} className="bg-white rounded-2xl p-8 shadow-xl space-y-4 max-w-lg mx-auto">
              <h3 className="text-xl font-bold text-gray-900 mb-2">预约免费咨询</h3>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">您的姓名 *</label>
                <input required type="text" placeholder="张三" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                  value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">公司名称 *</label>
                <input required type="text" placeholder="示例科技有限公司" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                  value={formData.company} onChange={(e) => setFormData({ ...formData, company: e.target.value })} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">联系电话 *</label>
                <input required type="tel" placeholder="138-0000-0000" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                  value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">您感兴趣的产品</label>
                <select className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none bg-white"
                  value={formData.need} onChange={(e) => setFormData({ ...formData, need: e.target.value })}>
                  <option value="">请选择...</option>
                  <option value="智小客">智小客 - AI客服</option>
                  <option value="销小帮">销小帮 - AI销售</option>
                  <option value="办小助">办小助 - AI办公</option>
                  <option value="全定制">全定制 - 定制服务</option>
                  <option value="多个产品">多个产品组合</option>
                </select>
              </div>
              <button type="submit" className="w-full py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition">
                提交咨询
              </button>
            </form>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">智</span>
              </div>
              <span className="text-white font-bold text-lg">智纬AI</span>
            </div>
            <div className="flex gap-6 text-sm">
              <Link to="/" className="hover:text-white transition">首页</Link>
              <Link to="/pricing" className="hover:text-white transition">定价</Link>
              <a href="#contact" className="hover:text-white transition">联系我们</a>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
            © 2026 智纬AI westilt.com 版权所有
          </div>
        </div>
      </footer>
    </div>
  );
}
